import { Switch, styled } from '@mui/material';

export const TempoSwitch = styled(Switch)(({ theme }) => ({
  width: 33,
  height: 20,
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',

  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 3,
    top: 'none',

    '&.Mui-checked': {
      transform: 'translateX(12px)',

      '& + .MuiSwitch-track': {
        opacity: 1,

        background:
          'linear-gradient(179.4deg, #01ACA4 -21.28%, #1D3557 72.79%, #190E1F 100.33%)',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 14,
    height: 14,
    top: 3,

    left: 16,
    borderRadius: 3,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 4,
    opacity: 1,
    backgroundColor: '#CCCCCC',
    boxSizing: 'border-box',
  },
}));
